import { render } from "./CadastroCarreta.vue?vue&type=template&id=4981d8b0"
import script from "./CadastroCarreta.vue?vue&type=script&lang=ts"
export * from "./CadastroCarreta.vue?vue&type=script&lang=ts"
script.render = render

export default script